import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const trackSignupPageChange: CheckoutActionCreator = (step) => (dispatch) => {
  dispatch({ type: actionTypes.SIGNUP_TRACKING_STEP_CHANGE, step })
}
